import * as Yup from 'yup'

export default Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
	email: Yup.string().email('Invalid email address. Please enter a new email address.').required('Email is Required'),
	password: Yup.string().required('Password is required').min(8, 'Your password needs to have at least 8 characters.'),
})
